import { Button, Group, Popover, TextInput } from '@mantine/core';
import { RichTextEditor } from '@mantine/tiptap';
import { IconPhotoPlus } from '@tabler/icons-react';
import type { Editor } from '@tiptap/react';
import { i18nKeys, useTranslation } from 'locales/index';
import { useState } from 'react';
import { isEmpty } from 'remeda';

type ImageFromUrlControlProps = {
  editor: Editor | null;
};

export const ImageFromUrlControl = ({ editor }: ImageFromUrlControlProps) => {
  const { t } = useTranslation();
  const [opened, setOpened] = useState(false);
  const [url, setUrl] = useState('');

  const insert = () => {
    if (isEmpty(url)) return;
    editor?.chain().focus().setImage({ src: url }).run();
    setUrl('');
    setOpened(false);
  };

  return (
    <Popover opened={opened} onChange={setOpened} withArrow trapFocus position="bottom">
      <Popover.Target>
        <RichTextEditor.Control
          aria-label={t(i18nKeys.IMAGE_FROM_URL)}
          title={t(i18nKeys.IMAGE_FROM_URL)}
          onClick={() => setOpened(isOpen => !isOpen)}
        >
          <IconPhotoPlus stroke={1.5} size={16} />
        </RichTextEditor.Control>
      </Popover.Target>
      <Popover.Dropdown>
        <Group gap="xs">
          <TextInput
            placeholder="https://..."
            value={url}
            onChange={event => setUrl(event.currentTarget.value)}
            onKeyDown={event => {
              if (event.key === 'Enter') insert();
            }}
          />
          <Button onClick={insert}>{t(i18nKeys.CONFIRM)}</Button>
        </Group>
      </Popover.Dropdown>
    </Popover>
  );
};
